import { Component, inject } from '@angular/core';
import { AlertService } from '../alert/alert.service';

@Component({
  selector: 'app-whatsapp-button',
  standalone: true,
  imports: [],
  templateUrl: './whatsapp-button.component.html',
  styleUrl: './whatsapp-button.component.scss'
})
export class WhatsappButtonComponent {

alertService = inject(AlertService);

  navegateCv() {
    this.alertService.openDialog({
      type: "dialog",
      title: "¡Estás a un clic de abrirte a un mundo de posibilidades!",
      message: 'Ingresarás a la página de Mi Eslabón para crear tu hoja de vida gratuita. Solo debes registrarte.',
      actions: {
        confirm: {
          show: true,
          label: "Aceptar",
        },
        cancel: {
          "show": true,
          "label": "Cancelar"
        }
      },
      onConfirm: () => {
        window.open("https://plataforma.mieslabon.com/app/organizaciones/ingresar/medellinjoven/71327", "_blank", "noopener,noreferrer");
        

      },
    });
  }

}
